import { Calendar, Chat, Document, Password, User, UserIcon, World } from "../../../components/styled/AllImages";
import ChangePasswordForm from "./ChangePasswordForm";
import ContactInformation from "./ContactInformation";
import FalInformation from "./FalInformation";
import PersonalInformation from "./PersonalInformation";
import SetAvailability from "./SetAvailability";
import WebSocialMedia from "./WebSocialMedia";



export const tabsArrayList = [
  {
    title: "PersonalInformation",
    icon: User,
    component: PersonalInformation,
  },
  {
    title: "FALInformation",
    icon: Document,
    component: FalInformation,
  },
  {
    title: "ContactDetails",
    icon: Chat,
    component: ContactInformation,
  },
  {
    title: "WebSocialMedia",
    icon: World,
    component: WebSocialMedia,
  },
  
];
export const settingsTabsList = [
  {
    title: "ChangePassword",
    icon: User,
    component: ChangePasswordForm,
  },
  {
    title: "setAvailability",
    icon: Calendar,
    component: SetAvailability,
  },
  
];
